<template>
  <div>
    <div id="contact" class="footerContent">
      <div class="bg-contact">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <ul class="list">
                <li>
                  <img
                    style="max-width: 200px"
                    :src="require('../assets/dompetkilat.png')"
                    alt="John"
                  />
                  <div class="address">
                    <div>
                      Gedung Mutiara Building
                      Lt. 2 - Unit 205
                      Jl. Mampang Prapatan Raya No. 10
                      Jakarta Selatan, DKI Jakarta 12790
                    </div>
                  </div>
                </li>
                <li>
                  <div class="numberphone">
                    <span> (021)319-34699 </span>
                    <span>cs@dompetkilat.co.id</span>
                  </div>
                </li>
                <li>
                  <div class="address-1">
                    <img
                      src="../assets/BottomNav/Button-call.png"
                      class="button-call"
                    />
                  </div>
                </li>
              </ul>
            </div>

            <div class="col-md-3">
              <ul class="list">
                <li>
                  <div class="midlle">
                    <div class="footerTitle">
                      <span>Berizin dan diawasi oleh OJK</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="midlle">
                    <div class="footerTitle">
                      <span>Tergabung dalam AFPI</span>
                    </div>

                    <img
                      class="afpiLogo"
                      :src="require('../assets/BottomNav/Logo-AFPI-new.png')"
                      alt
                    />
                  </div>
                </li>
              </ul>
            </div>

            <div class="col-md-3">
              <ul class="list">
                <li>
                  <div class="footerTitle">
                    <span>Menu</span>
                  </div>
                </li>
                <li>
                  <v-row no-gutters>
                    <!-- <v-col>
                      <div class="menuLink" @click="goToPage('pendanaan')">
                        Pendanaan
                      </div>
                      <div class="menuLink" @click="goToPage('pinjaman')">
                        Pinjaman
                      </div>
                      <div class="menuLink" @click="goToPage('produk')">
                        Produk
                      </div>
                      <div class="menuLink" @click="goToBlog">Blog</div>
                    </v-col> -->
                    <v-col>
                      <div class="menuLink" @click="goToPage('tentang-kami')">
                        Tentang Kami
                      </div>
                      <div class="menuLink" @click="goToPage('hubungi-kami')">
                        Hubungi kami
                      </div>
                      <div
                        class="menuLink"
                        @click="goToPage('syarat-ketentuan')"
                      >
                        Syarat & ketentuan
                      </div>
                      <div
                        v-if="$route.name == 'Tentang Kami'"
                        class="menuSpecialLink"
                        @dblclick="goToPage('informasi-lainnya')"
                      >
                        Informasi Lainnya
                      </div>
                    </v-col>
                  </v-row>
                </li>
              </ul>
            </div>
            <div class="col-md-2">
              <ul class="list">
                <li>
                  <div class="footerTitle">
                    <span>Aplikasi Dompet Kilat</span>
                  </div>
                </li>
              </ul>
              <ul style="margin-top: -12px">
                <v-img
                  class="gplay"
                  style="margin-left: -25px"
                  contain
                  :src="require('../assets/BottomNav/ButtonApp.png')"
                  @click="note = true"
                />
              </ul>
              <ul class="list">
                <li>
                  <div class="footerTitle">
                    <span>Sosial media</span>
                  </div>
                </li>
              </ul>
              <ul class="media-list">
                <li>
                  <a href="https://twitter.com/dompetkilat/" target="_blank">
                    <img
                      class="socialIcon"
                      :src="require('../assets/BottomNav/Twitter.png')"
                      alt
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/dompetkilatofficial/"
                    target="_blank"
                  >
                    <img
                      class="socialIcon"
                      :src="require('../assets/BottomNav/Facebook.png')"
                      alt
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/dompet.kilat/"
                    target="_blank"
                  >
                    <img
                      class="socialIcon"
                      :src="require('../assets/BottomNav/Instagram.png')"
                      alt
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <v-dialog
        transition="dialog-bottom-transition"
        v-model="note"
        max-width="550"
      >
        <v-card>
          <v-card-title class="white--text popupTitle">
            Download Aplikasi Dompetkilat
          </v-card-title>
          <v-card-text>
            <div class="text-h6 black--text px-2 mt-6">
              Anda akan mengunduh aplikasi DompetKilat, Pastikan anda
              <span class="red--text font-weight-bold"
                >sudah memiliki kode akses</span
              >
            </div>
            <div class="text-h6 px-2 mt-6">
              Masukkan kode akses untuk melanjutkan

              <v-text-field
                class="mt-2"
                v-model="noteCode"
                label="Kode Akses"
                color="#D3352C"
                outlined
                dense
                required
              ></v-text-field>
              <strong
                v-if="noteError"
                class="text-body-1 red--text text--lighten-1"
                >Kode Akses Salah !!</strong
              >
            </div>
          </v-card-text>
          <v-divider class="mx-4" />
          <v-card-actions class="justify-end">
            <div class="pb-2">
              <v-btn
                class="white--text text-none"
                color="#D3352C"
                min-width="125"
                rounded
                @click="closeNote"
                >Batal</v-btn
              >
              <v-btn
                class="ml-4 text-none"
                min-width="125"
                outlined
                color="black"
                rounded
                @click="toDownload"
                >Selanjutnya</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="tofm">
        <div class="container">
          <p class="footerTitle">Perhatian</p>
          <v-row no-gutters>
            <v-col>
              <div class="warningContent">
                Layanan Pinjam Meminjam Berbasis Teknologi Informasi merupakan
                kesepakatan perdata antara Pemberi Pinjaman dengan Penerima
                Pinjaman, sehingga segala risiko yang timbul dari kesepakatan
                tersebut ditanggung sepenuhnya oleh masing-masing pihak.
              </div>
              <div class="warningContent">
                Risiko kredit atau gagal bayar ditanggung sepenuhnya oleh
                Pemberi Pinjaman. Tidak ada lembaga atau otoritas negara yang
                bertanggung jawab atas risiko gagal bayar ini.
              </div>
              <div class="warningContent">
                Penyelenggara dengan persetujuan dari masing-masing Pengguna
                (Pemberi Pinjaman dan/atau Penerima Pinjaman) mengakses,
                memperoleh, menyimpan, mengelola dan/atau menggunakan data
                pribadi Pengguna (Pemanfaatan Data) pada atau di dalam benda,
                perangkat elektronik (termasuk smartphone atau telepon seluler),
                perangkat keras (hardware) maupun lunak (software), dokumen
                elektronik, aplikasi atau sistem elektronik milik Pengguna atau
                yang dikuasai Pengguna, dengan memberitahukan tujuan, Batasan
                dan mekanisme Pemanfaatan Data tersebut kepada Pengguna atau
                yang dikuasai Pengguna, dengan memberitahukan tujuan, Batasan
                dan mekanisme Pemanfaatan Data tersebut kepada Pengguna yang
                bersangkutan sebelum memperoleh persetujuan yang dimaksud.
              </div>
              <div class="warningContent">
                Pemberi Pinjaman yang belum memiliki pengetahuan dan pengalaman
                pinjam meminjam, disarankan untuk tidak menggunakan layanan ini.
              </div>
            </v-col>
            <v-col class="warningContainerTwo">
              <div class="warningContent">
                Setiap kecurangan tercatat secara digital di dunia maya dan
                dapat diketahui masyarakat luas di media sosial.
              </div>
              <div class="warningContent">
                Pengguna harus membaca dan memahami informasi ini sebelum
                membuat keputusan menjadi Pemberi Pinjaman atau Penerima
                Pinjaman.
              </div>
              <div class="warningContent">
                Pemerintah yaitu dalam hal ini Otoritas Jasa Keuangan, tidak
                bertanggung jawab atas setiap pelanggaran atau ketidakpatuhan
                oleh Pengguna, baik Pemberi Pinjaman maupun Penerima Pinjaman
                (baik karena kesengajaan atau kelalaian Pengguna) terhadap
                ketentuan peraturan perundang-undangan maupun kesepakatan atau
                perikatan antara Penyelenggara dengan Pemberi Pinjaman dan/atau
                Penerima Pinjaman.
              </div>
              <div class="warningContent">
                Setiap transaksi dan kegiatan pinjam meminjam atau pelaksanaan
                kesepakatan mengenai pinjam meminjam antara atau yang melibatkan
                Penyelenggara, Pemberi Pinjaman, dan/atau Penerima Pinjaman
                wajib dilakukan melalu escrow account dan virtual account
                sebagaimana yang diwajibkan berdasarkan Peraturan Otoritas Jasa
                Keuangan Nomor 77/POJK 01/2016 tentang Layanan Pinjam Meminjam
                Uang Berbasis Teknologi Informasi dan pelanggaran atau
                ketidakpatuhan terhadap ketentuan tersebut merupakan bukti telah
                terjadinya pelanggaran hukum oleh Penyelenggara sehingga
                Penyelenggara wajib menanggung ganti rugi yang diderita oleh
                masing-masing Pengguna sebagai akibat langsung dari pelanggaran
                hukum tersebut di atas tanpa mengurangi hak Pengguna yang
                menderita kerugian menurut Kitab Undang Undang Hukum Perdata
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <!-- <div class="contaner-fluid p-5-hor">
        <hr />
      </div> -->
    </div>

    <v-footer color="#252525" padless>
      <v-row justify="center" no-gutters>
        <v-col class="py-4 text-center copyrightText" cols="12">
          Copyright © PT Indo Fin Tek 2016 - 2022
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      bottomNav: "home",
      widthNow: window.innerWidth,
      note: false,
      noteError: false,
      noteCode: "",
    };
  },
  methods: {
    goToPage(str) {
      this.$router.push("/" + str);
    },
    goToBlog() {
      window.location = "https://blog.dompetkilat.co.id/";
    },
    forceFileDownload(response) {
      window.open(response.data.data.url);
    },
    download(url) {
      axios({
        method: "get",
        url,
      })
        .then((response) => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    },
    toDownload() {
      if (this.noteCode === "3k0s1stemDK") {
        this.download("https://dompetkilat.co.id/apks/dompetkilat.apk");
        this.noteCode = "";
        this.note = false;
        this.noteError = false;
      } else {
        this.noteError = true;
      }
    },
    closeNote() {
      this.note = false;
      this.noteCode = "";
      this.noteError = false;
    },
  },
};
</script>

<style>
.address {
  max-width: 361px;
  flex-grow: 0;
  margin: 18px 0 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.numberphone {
  display: flex;
  justify-content: space-between;
  font-family: Inter;
  font-size: 14px;
}
.address-1 {
  max-width: 361px;
  flex-grow: 0;
  margin: 18px 0 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  font-weight: normal;
}
.button-call {
  max-width: 200px;
}
.footerTitle {
  flex-grow: 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.menuLink {
  flex-grow: 0;
  margin-bottom: 10px;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  cursor: pointer;
}
.list {
  max-width: 340px;
}
.menuSpecialLink {
  flex-grow: 0;
  margin-bottom: 10px;
  font-family: Inter;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  cursor: default;
}
.socialIcon {
  max-width: 32px;
  max-height: 32px;
  flex-grow: 0;
  object-fit: contain;
}
.warningContainerTwo {
  margin-left: 5rem;
}
.warningContent {
  margin-bottom: 1.5rem;
  flex-grow: 0;
  font-family: Inter;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.58;
  letter-spacing: normal;
  text-align: left;
  color: #8e8e8e;
}
.copyrightText {
  flex-grow: 0;
  font-family: Inter;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.18;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.afpiLogo {
  max-width: 202px;
  max-height: 131px;
}
.footerContent {
  margin-left: 15rem;
  margin-right: 15rem;
}
.popupTitle {
  background-color: #d3352c;
}
@media screen and (max-width: 1200px) {
  .footerContent {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
